import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getUserReward} from '../../../apis/cashback/getUserReward'

const useQueryReward = (user_id?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.payback.getReward(user_id),
        queryFn: async () => {
            const {data} = await getUserReward(user_id)
            return {data}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryReward
